import Role from '@/types/user/role'
import { BaseService } from '../../base'
export class RoleService extends BaseService<Role>() {
    static get entity(): string {
        return 'role'
    }
    static get responseName(): string {
        return 'role'
    }
}